// Randevu sistemi (v1.22.0) — ortak tipler, durum/sonuç tanımları ve yardımcılar.

export type RandevuDurum = 'PLANLANDI' | 'ONAYLANDI' | 'TAMAMLANDI' | 'IPTAL' | 'ERTELENDI' | 'GELMEDI';
export type RandevuSonuc = 'ILGILENDI' | 'TEKLIF_ISTENDI' | 'SATIS' | 'DUSUNUYOR' | 'ILGILENMEDI' | 'DIGER';

export interface RandevuOzet {
    randevuID: number;
    baslik: string;
    turID?: number | null;
    turAdi?: string | null;
    renk: string;
    ikon?: string | null;
    personelID: number;
    personelAdi?: string | null;
    baslangic: string;
    bitis: string;
    konum?: string | null;
    cariID?: number | null;
    cariAdi?: string | null;
    leadID?: number | null;
    leadAdi?: string | null;
    projeID?: number | null;
    projeAdi?: string | null;
    kaynakID?: number | null;
    kaynakAdi?: string | null;
    musteriAdi?: string | null;
    durum: RandevuDurum;
    sonuc?: RandevuSonuc | null;
    musteriOnay?: 'ONAYLADI' | 'IPTAL_ETTI' | null;
    tekrarGrupID?: string | null;
    onlineAlindi: boolean;
}

export interface RandevuDetay {
    randevu: RandevuOzet;
    aciklama?: string | null;
    gorusmeNotu?: string | null;
    iptalNedeni?: string | null;
    musteriBildirim: boolean;
    hatirlatmaDk?: number | null;
    tekrarKural?: string | null;
    tekrarSayisi: number;
    musteriOnayTarihi?: string | null;
    takipID?: number | null;
    olusturmaTarihi: string;
    musteriAdi?: string | null;
    musteriTelefon?: string | null;
    musteriEposta?: string | null;
    musteri: { ad?: string | null; telefon?: string | null; eposta?: string | null };
    olusturanAdi?: string | null;
    onayLinki?: string | null;
    musteriToken: string;
    duzenleyebilir: boolean;
}

export interface RandevuTuru { turID: number; ad: string; renk: string; ikon?: string | null; varsayilanSure: number; siraNo: number; aktifMi: boolean; }
export interface RandevuKaynagi { kaynakID: number; ad: string; tur: string; aciklama?: string | null; projeID?: number | null; aktifMi: boolean; }
export interface RandevuPersonel { kullaniciID: number; adSoyad: string; randevuAlabilir: boolean; ben: boolean; }
export interface RandevuGenelAyar {
    personelHatirlatmaDk: number; musteriHatirlatmaSaat: number; musteriSms: boolean; musteriEposta: boolean;
    onlineRandevuAktif: boolean; onlineMinSaat: number; onlineMaxGun: number; siteUrl?: string | null;
}
export interface RandevuTanimlar {
    turler: RandevuTuru[];
    kaynaklar: RandevuKaynagi[];
    personel: RandevuPersonel[];
    tumPersonel: { kullaniciID: number; adSoyad: string }[];
    yoneticiMi: boolean;
    tanimYetkisi: boolean;
    ayarlar: RandevuGenelAyar | null;
    onlineRandevuAktif: boolean;
}

export const DURUMLAR: { d: RandevuDurum; ad: string; renk: string; zemin: string; ikon: string }[] = [
    { d: 'PLANLANDI',  ad: 'Planlandı',  renk: '#2563eb', zemin: '#dbeafe', ikon: 'fa-calendar' },
    { d: 'ONAYLANDI',  ad: 'Onaylandı',  renk: '#0d9488', zemin: '#ccfbf1', ikon: 'fa-calendar-check' },
    { d: 'TAMAMLANDI', ad: 'Tamamlandı', renk: '#16a34a', zemin: '#dcfce7', ikon: 'fa-check-circle' },
    { d: 'IPTAL',      ad: 'İptal',      renk: '#dc2626', zemin: '#fee2e2', ikon: 'fa-times-circle' },
    { d: 'ERTELENDI',  ad: 'Ertelendi',  renk: '#a16207', zemin: '#fef3c7', ikon: 'fa-history' },
    { d: 'GELMEDI',    ad: 'Gelmedi',    renk: '#7c3aed', zemin: '#ede9fe', ikon: 'fa-user-slash' },
];
export const durumMeta = (d?: string | null) => DURUMLAR.find(x => x.d === d) ?? DURUMLAR[0];
export const aktifDurum = (d: string) => d === 'PLANLANDI' || d === 'ONAYLANDI';

export const SONUCLAR: { s: RandevuSonuc; ad: string; ikon: string }[] = [
    { s: 'ILGILENDI',      ad: 'İlgilendi',      ikon: 'fa-thumbs-up' },
    { s: 'TEKLIF_ISTENDI', ad: 'Teklif istendi', ikon: 'fa-file-invoice' },
    { s: 'SATIS',          ad: 'Satış oldu',     ikon: 'fa-handshake' },
    { s: 'DUSUNUYOR',      ad: 'Düşünüyor',      ikon: 'fa-hourglass-half' },
    { s: 'ILGILENMEDI',    ad: 'İlgilenmedi',    ikon: 'fa-thumbs-down' },
    { s: 'DIGER',          ad: 'Diğer',          ikon: 'fa-ellipsis-h' },
];
export const sonucAdi = (s?: string | null) => SONUCLAR.find(x => x.s === s)?.ad;

export const KAYNAK_TURLERI = [
    { t: 'ODA', ad: 'Toplantı odası', ikon: 'fa-door-closed' },
    { t: 'NUMUNE_DAIRE', ad: 'Numune daire', ikon: 'fa-home' },
    { t: 'ARAC', ad: 'Araç', ikon: 'fa-car' },
    { t: 'DIGER', ad: 'Diğer', ikon: 'fa-cube' },
];

export const TEKRAR_TIPLERI = [
    { t: '', ad: 'Tekrar yok' },
    { t: 'GUNLUK', ad: 'Her gün' },
    { t: 'HAFTALIK', ad: 'Her hafta' },
    { t: 'IKI_HAFTALIK', ad: 'İki haftada bir' },
    { t: 'AYLIK', ad: 'Her ay' },
];

export const GUN_ADLARI = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
export const GUN_KISA = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];

// ── Tarih yardımcıları (sunucu yerel saat ile çalışır; ISO'da saat dilimi yok) ──
export const iki = (n: number) => String(n).padStart(2, '0');
export const tarihStr = (d: Date) => `${d.getFullYear()}-${iki(d.getMonth() + 1)}-${iki(d.getDate())}`;
export const saatStr = (d: Date) => `${iki(d.getHours())}:${iki(d.getMinutes())}`;
export const yerelIso = (d: Date) => `${tarihStr(d)}T${saatStr(d)}:00`;
export const tarihOku = (s: string) => new Date(s.length === 10 ? s + 'T00:00:00' : s.replace(/Z$/, ''));
export const gunBasi = (d: Date) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
export const gunEkle = (d: Date, n: number) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const haftaBasi = (d: Date) => { const x = gunBasi(d); const g = (x.getDay() + 6) % 7; return gunEkle(x, -g); };   // Pazartesi
export const ayniGun = (a: Date, b: Date) => tarihStr(a) === tarihStr(b);

export const tarihEtiket = (s: string, secenek: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', weekday: 'long' }) =>
    tarihOku(s).toLocaleDateString('tr-TR', secenek);
export const saatAraligi = (r: { baslangic: string; bitis: string }) => `${saatStr(tarihOku(r.baslangic))}–${saatStr(tarihOku(r.bitis))}`;
export const sureDk = (r: { baslangic: string; bitis: string }) => Math.round((tarihOku(r.bitis).getTime() - tarihOku(r.baslangic).getTime()) / 60000);

export const haritaUrl = (konum: string) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(konum)}`;
export const yolTarifiUrl = (konum: string) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(konum)}`;

export function hataMesaji(e: any, varsayilan = 'İşlem sırasında hata oluştu.'): string {
    return e?.response?.data?.message || varsayilan;
}

// ── Olaylar ──
export const RANDEVU_AC_OLAYI = 'yapicrm:randevu-ac';
export const RANDEVU_DEGISTI_OLAYI = 'yapicrm:randevu-degisti';
export const randevuAc = (id: number) => window.dispatchEvent(new CustomEvent(RANDEVU_AC_OLAYI, { detail: id }));
export const randevuDegisti = () => window.dispatchEvent(new CustomEvent(RANDEVU_DEGISTI_OLAYI));

// Randevu formunu dışarıdan açmak için (ör. kayıt sayfası, takvimde boş alana tıklama)
export interface RandevuVarsayilan {
    baslangic?: Date;
    bitis?: Date;
    personelID?: number;
    cari?: { id: number; ad: string } | null;
    lead?: { id: number; ad: string } | null;
    projeID?: number | null;
}
